import { render, staticRenderFns } from "./PowerpointEditorNotify.vue?vue&type=template&id=1f0d24b2&scoped=true"
import script from "./PowerpointEditorNotify.vue?vue&type=script&lang=js"
export * from "./PowerpointEditorNotify.vue?vue&type=script&lang=js"
import style0 from "./PowerpointEditorNotify.vue?vue&type=style&index=0&id=1f0d24b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0d24b2",
  null
  
)

export default component.exports